document.addEventListener("DOMContentLoaded", function () {
  const customerLoginForm = document.querySelector(
    'form[action="/account/login"]'
  );
  const recoverPasswordForm = document.querySelector(
    'form[action="/account/recover"]'
  );
  const recoverLink = document.querySelector('a[href="#recover"]');
  const cancelRecoverLink = document.querySelector('a[href="#cancel-recover"]');
  const recoverSection = document.getElementById("recover");

  // Show/Hide Recover Password Form
  if (recoverLink && recoverSection) {
    recoverLink.addEventListener("click", function (event) {
      event.preventDefault();
      customerLoginForm.style.display = "none";
      recoverSection.style.display = "block";
    });
  }

  // Hide Recover Password Form
  if (cancelRecoverLink) {
    cancelRecoverLink.addEventListener("click", function (event) {
      event.preventDefault();
      recoverSection.style.display = "none";
      customerLoginForm.style.display = "block";
    });
  }

  // Simple Form Validation
  if (customerLoginForm) {
    customerLoginForm.addEventListener("submit", function (event) {
      let valid = true;
      const email = customerLoginForm.querySelector(
        "input[name='customer[email]']"
      );
      const password = customerLoginForm.querySelector(
        "input[name='customer[password]']"
      );

      // Validate Email
      if (!email.value || !validateEmail(email.value)) {
        valid = false;
        alert("Please enter a valid email address.");
      }

      // Validate Password
      if (!password.value) {
        valid = false;
        alert("Please enter your password.");
      }

      if (!valid) {
        event.preventDefault();
      }
    });
  }

  // Helper Function to Validate Email
  function validateEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }
});
